module.exports = __webpack_public_path__ + "static/img/news-logo-10.2aaca50.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/news/news-logo-10.png
// module id = Tg0k
// module chunks = 1